var t=function(r){return r.address="address",r.city="city",r.hotel="hotel",r}({});export{t as FoundLocationType};